import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ApiResourceService } from '../../apiResource/apiResource.service';
import { IAirApplicationAutomatorRequest, IAirSaveOfferRequest } from "../model/booking/air/IAirSaveOffer";
import {IAirGetQuotedAvailabilityRequest} from "../model/booking/air/IAirQuotedAvailability";

const URL_AIR: string = 'air';
const URL_OFFERS: string = 'offers';
const URL_SAVE: string = 'save';
const URL_BEST: string = 'best';
const URL_VALIDATE: string = 'validate';

@Injectable()
export class AirOfferResourceService {

    constructor(
        private readonly apiResourceService: ApiResourceService
    ) {
    }

    public postOffer(body: IAirSaveOfferRequest, target: string): Observable<any> {
        return this.apiResourceService.postOne<IAirSaveOfferRequest, any>(
            this.apiResourceService.getApiUrl(URL_AIR, URL_OFFERS, URL_SAVE),
            body, {}, { target }
        );
    }

    public postBestOffer(body: IAirApplicationAutomatorRequest, target: string): Observable<any> {
        return this.apiResourceService.postOne<IAirApplicationAutomatorRequest, any>(
            this.apiResourceService.getApiUrl(URL_AIR, URL_OFFERS, URL_SAVE, URL_BEST),
            body, {}, { target }
        );
    }

    public getOffer(body: IAirApplicationAutomatorRequest, target: string): Observable<IAirGetQuotedAvailabilityRequest> {
        return this.apiResourceService.postOne(
            this.apiResourceService.getApiUrl(URL_AIR, URL_OFFERS, URL_VALIDATE),
            body, {}, { target }
        );
    }
}
